import * as S from "./ContentSection.style";

interface ContentSectionProps {
  children?: React.ReactNode;
}

export const ContentSection = ({ children }: ContentSectionProps) => {
  return <S.ContentSection>{children}</S.ContentSection>;
};
